import React from 'react';
import PageContainer from './components/ui/PageContainer';
import Router from './components/Router';
import CustomerNav from './components/customer/CustomerNav';
import CustomerView from './components/customer/CustomerView';
import Messages from './features/messages/Messages';

function App() {

  return (
    <PageContainer>
      <CustomerNav/>
      <CustomerView>
        <Messages/>
        <br/>
        <Router/>
      </CustomerView>
    </PageContainer>
  )
}

export default App;
